export var parseJSON = function (obj) {
    try {
        return obj ? JSON.parse(obj) : undefined;
    }
    catch (_a) {
        return undefined;
    }
};
export var parseSerializedValue = function (wrappedValue) {
    return wrappedValue ? Number(wrappedValue.serializedValue) : undefined;
};
//# sourceMappingURL=parsing.js.map